"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("../../..");
// TODO: Better type definition
exports.getMutationVariablesForBlocks = (id, blocks, html, defaultContentFeedSecond, emailTemplateVersion) => {
    return {
        data: {
            blocks: __1.blocksToInputData(blocks),
            defaultContentFeedId: defaultContentFeedSecond
                ? defaultContentFeedSecond.id
                : null,
            emailTemplateVersionId: emailTemplateVersion
                ? emailTemplateVersion.id
                : null,
            html,
        },
        id,
    };
};
//# sourceMappingURL=getMutationVariablesForBlocks.js.map